// extracted by mini-css-extract-plugin
export default {"wrap":"oD-z","logoContainer":"pD-z","brandImg":"qD-z","logoImg":"rD-z","logoButton":"sD-z"};